import React, {useCallback, useEffect, useState} from 'react';
import {CommonService} from "../../services";
import {Misc} from "../../../constants";
import {logout, setLoggedInUserData, setLoggedInUserToken} from "../../../store/actions/account.action";
import {useDispatch} from "react-redux";
import {IAPIResponseType} from "../../models/api.model";
import {ICheckLoginResponse} from "../../models/account.model";
import PageLoaderComponent from "../page-loader/pageLoaderComponent";

interface CheckLoginComponentProps {

}

const CheckLoginComponent = (props: React.PropsWithChildren<CheckLoginComponentProps>) => {

    const {children} = props;
    const dispatch = useDispatch();
    const [isLoading, setIsLoading] = useState(false);
    const [isLoaded, setIsLoaded] = useState(false);

    const checkLogin = useCallback(() => {
        // const token = CommonService._localStorage.getItem(Misc.LOCAL_STORAGE_JWT_TOKEN) || "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJfaWQiOiI2M2UzNmM2NThhNmQ2N2JlN2VjZmRhMDkiLCJjbGllbnRfaWQiOiIwMDAwMDA4OCIsImZpcnN0X25hbWUiOiJNYW5vaiBLdW1hciIsImxhc3RfbmFtZSI6IiBCIiwicHJpbWFyeV9lbWFpbCI6Im1hbm9qdmFybWFAdGVyaWNzb2Z0LmNvbSIsInByaW1hcnlfY29udGFjdF9pbmZvIjp7InBob25lX3R5cGUiOiJtb2JpbGUiLCJwaG9uZSI6Iig4ODgpLTg4OC04MTExIiwicGhvbmVfdHlwZV9kZXRhaWxzIjp7Il9pZCI6IjYzN2Y0MjBkZDhhN2NmMDEwZjE0OTBiNiIsInRpdGxlIjoiTW9iaWxlIiwiY29kZSI6Im1vYmlsZSJ9fSwiaWF0IjoxNjc5OTEyNDg2LCJleHAiOjE2ODAwODUyODZ9.7ZLHG2hkkJl6O8wm4qUoRRHPx6QC0o7NpJL2H3Cys3Y";
        const token = CommonService._localStorage.getItem(Misc.LOCAL_STORAGE_JWT_TOKEN);
        if (token) {
            setIsLoading(true);
            CommonService._account.CheckLoginAPICall(token)
                .then((response: IAPIResponseType<ICheckLoginResponse>) => {
                    setIsLoading(false);
                    setIsLoaded(true);
                    dispatch(setLoggedInUserData(response?.data?.user));
                    dispatch(setLoggedInUserToken(token));
                })
                .catch(() => {
                    dispatch(logout());
                    setIsLoading(false);
                    setIsLoaded(true);
                })
        } else {
            setIsLoading(false);
            setIsLoaded(true);
        }
    }, [dispatch]);

    useEffect(() => {
        checkLogin();
    }, [checkLogin]);

    return (
        <>
            {(isLoading && !isLoaded) && <PageLoaderComponent/>}
            {isLoaded && children}
        </>
    )
};

export default CheckLoginComponent;
